import Colors from "@constants/Colors";
import { Dialog } from "@mui/material";
import {
  CustomButtonLogOut,
  LeavePageModalWrapper,
  LogOutButtonWrapper,
  LogOutTextWrapper,
} from "./styles";

interface LeavePageModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const LeavePageModal = (props: LeavePageModalProps) => {
  const { open, onClose, onConfirm } = props;

  return (
    <Dialog onClose={() => onClose} open={open}>
      <LeavePageModalWrapper>
        <LogOutTextWrapper>
          If you leave this page or finish editing, you will lose all unsaved
          changes.
        </LogOutTextWrapper>
        <br />
        <LogOutButtonWrapper>
          <CustomButtonLogOut
            onClick={onClose}
            textColor={Colors.secondary}
            backgroundColor={Colors.neutral_gray_100}
          >
            Cancel
          </CustomButtonLogOut>
          <CustomButtonLogOut
            onClick={onConfirm}
            textColor={Colors.white}
            backgroundColor={Colors.secondary}
          >
            Confirm
          </CustomButtonLogOut>
        </LogOutButtonWrapper>
      </LeavePageModalWrapper>
    </Dialog>
  );
};

export default LeavePageModal;
